var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWhatsappAltcomponent = function SvgWhatsappAltcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#whatsapp-alt_component_svg__a)",
    fill: "#413E3B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8 24 1.202-4.363a8.343 8.343 0 0 1-1.129-4.214c0-4.646 3.8-8.423 8.463-8.423a8.42 8.42 0 0 1 5.988 2.468A8.333 8.333 0 0 1 25 15.428c0 4.645-3.8 8.422-8.468 8.422h-.004a8.503 8.503 0 0 1-4.047-1.026L8 24Zm4.697-2.699.255.154a7.08 7.08 0 0 0 3.58.978h.005c3.876 0 7.034-3.14 7.034-7.002a6.95 6.95 0 0 0-2.058-4.953 6.998 6.998 0 0 0-4.977-2.052c-3.876-.004-7.034 3.135-7.034 6.997 0 1.321.37 2.61 1.076 3.725l.166.267-.71 2.581 2.662-.695Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.422 11.9c-.159-.351-.325-.36-.475-.363-.122-.004-.264-.004-.406-.004a.78.78 0 0 0-.564.262c-.195.21-.74.72-.74 1.758 0 1.034.76 2.036.865 2.177.106.142 1.466 2.335 3.613 3.18 1.786.703 2.151.561 2.537.525.386-.037 1.25-.51 1.429-1.002.174-.493.174-.913.122-1.002-.053-.089-.195-.141-.406-.246-.211-.105-1.25-.614-1.445-.687-.195-.069-.337-.105-.475.105-.142.21-.548.683-.67.824-.122.142-.248.158-.459.053-.21-.105-.893-.328-1.7-1.047a6.297 6.297 0 0 1-1.178-1.458c-.121-.21-.012-.323.094-.428.093-.093.21-.247.316-.368.106-.121.142-.21.211-.351.07-.142.037-.263-.016-.368-.053-.101-.467-1.143-.653-1.56Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "whatsapp-alt_component_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8 7)",
    d: "M0 0h17v17H0z"
  })))));
};
export default SvgWhatsappAltcomponent;